module.exports = __webpack_public_path__ + "static/media/profile_23.21dc8684.jpg";